import type { PropsWithChildren } from 'react'
import React, { useCallback, useState } from 'react'
import type { FilterStateT } from 'components/Filter/types'
import useFilterUtils from 'components/Filter/useFilterUtils'
import FiltersStorageContext from './context'

const FiltersStorageProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [filters, setFilters] = useState<FilterStateT>()
  const [name, setName] = useState('')
  const { setLoadFilterTasks, storeState } = useFilterUtils()

  const saveFilters = useCallback(() => {
    if (filters) {
      setLoadFilterTasks(name)
      storeState(name, filters)
    }
  }, [filters, name, setLoadFilterTasks, storeState])

  return (
    <FiltersStorageContext.Provider
      value={{
        filters,
        setFilters,
        name,
        setName,
        saveFilters,
      }}
    >
      {children}
    </FiltersStorageContext.Provider>
  )
}

export default FiltersStorageProvider
